define.alias("ember-math-helpers/helpers/atanh", "calendar/helpers/atanh");